/*  ========================================================================
    # Hooks - Use Booking Url
    ========================================================================  */

import { useMemo } from 'react';

const formatDate = date => {
  if (!date || !(date instanceof Date)) return undefined;
  return (
    date.getFullYear() +
    '-' +
    String(date.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(date.getDate()).padStart(2, '0')
  );
};

export default function useBookingUrl(
  baseUrl,
  arrival = undefined,
  departure = undefined,
  adults = 1,
  children = 0,
  culture = 'de-DE'
) {
  const url = useMemo(() => {
    // Build room format
    const roomString = [...Array(adults).fill('a'), ...Array(children).fill('12')].join(',');
    const u = new URL(baseUrl);
    u.searchParams.set('arrival', formatDate(arrival));
    u.searchParams.set('departure', formatDate(departure));
    u.searchParams.set('room', roomString);
    u.searchParams.set('culture', culture);
    return u.toString();
  }, [baseUrl, arrival, departure, adults, children, culture]);
  return url;
}
